// extracted by mini-css-extract-plugin
export var text = "_6n-0";